import { PrincipalLayouts } from '../../../layouts'
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Autocomplete, Button, Divider, InputBase, Stack, TextField, Typography } from "@mui/material"
import { useForm } from '../../../hooks';
import { NumberInput } from '../NumberInput';
import { createConfirmEvent, editConfirmEvent } from '../../helpers/confirmEvents';
import { useEffect, useState } from 'react';
import { fetchData } from '../../helpers/getData/fetchData';
import { useSelector } from 'react-redux';

export const ConfirmEvents = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { t } = useTranslation('global');
    const navigate = useNavigate()
    const [myCompaniesList, setMyCompaniesList] = useState('isLoading')
    const {avatar} = useSelector(state => state.auth);
    const myName = avatar.split('-')[0] + ' ' + avatar.split('-')[1]

    const [formValues, handleInputChange, reset] = useForm({ assistance: 'Si', principalAssistant: myName, comments: '', companions: '' });

    const { assistance, principalAssistant, comments, companions } = formValues;

    const handleConfirm = () => {
        if (assistance === 'Si') {
            if(searchParams.get('edit') === 'true'){
                editConfirmEvent({ ...formValues, eventId: searchParams.get('amount'), confirmsAttendance: "Confirmada" }, t('addevent.confirmRegistered'), t('addevent.errorRegistered'), t('addevent.errorRegistered'),)
            } else {
                createConfirmEvent({ ...formValues, eventId: searchParams.get('amount'), confirmsAttendance: "Confirmada" }, t('addevent.confirmRegistered'), t('addevent.errorRegistered'), t('addevent.errorRegistered'),)
            }
        } else {
            createConfirmEvent({ principalAssistant: '-', companions: 0, eventId: searchParams.get('amount'), confirmsAttendance: "NO" }, t('addevent.confirmRegistered'), t('addevent.errorRegistered'), t('addevent.errorRegistered'),)

        }
        navigate('/events')
    }

    const handleCancel = () => {
        reset()
        navigate('/events')
    }

    const onEventClick = () => {
        window.open(searchParams.get('url'), '_blank')
    }

    useEffect(() => {
        fetchData(setMyCompaniesList, '/companies/listName', t)
    }, [t])

    return (
        <PrincipalLayouts>
            {
                myCompaniesList !== 'isLoading' &&
                <>
                    <Stack direction='row' alignItems='center'>
                        <Typography color='primary' variant='h5'>{t('addevent.confirmAssist')}</Typography>
                        <Button color='secondary' variant="text" sx={{ fontSize: '24px' }} onClick={onEventClick}>{searchParams.get('event')}</Button>
                    </Stack>
                    <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

                    <form onSubmit={handleConfirm}>
                        <Stack minHeight='calc(100vh - 290px)' gap={2}>

                            <Stack >
                                <Typography variant='overline' color='secondary'>{t('addevent.assistance')}</Typography>
                                <Autocomplete
                                    disablePortal
                                    options={['Si', 'No']}
                                    size='small'
                                    renderInput={(params) => <TextField  {...params} variant='outlined' name='assistance' />}
                                    value={assistance}
                                    onSelect={handleInputChange}
                                    fullWidth
                                    required
                                />
                            </Stack>

                            {
                                assistance === 'Si' &&
                                <>
                                    <Stack width='100%' gap={2}>
                                        <Stack >
                                            <Typography variant='overline' color='secondary'>{t('addevent.principalAssistant')}</Typography>
                                            <Autocomplete
                                                disablePortal
                                                options={[...myCompaniesList, myName]}
                                                size='small'
                                                renderInput={(params) => <TextField  {...params} variant='outlined' name='principalAssistant' />}
                                                value={principalAssistant}
                                                onSelect={handleInputChange}
                                                fullWidth
                                                required
                                            />
                                        </Stack>
                                    </Stack>

                                    <Stack width='100%' gap={2}>
                                        <NumberInput name={companions} title='companions' handleInputChange={handleInputChange} required={true} />
                                    </Stack>

                                    <Typography variant='overline' color='secondary'>{t('addevent.comments')}</Typography>
                                    <InputBase
                                        fullWidth
                                        name='comments'
                                        size="small"
                                        variant="standard"
                                        value={comments}
                                        onChange={handleInputChange}
                                        type='text'
                                        multiline
                                    />

                                </>
                            }

                            <Stack direction='row' alignItems='center' marginTop='15px'>
                                <Typography color='primary' variant='body1'>{t('addevent.msgUrl')}</Typography>
                                <Button color='secondary' type='text' sx={{ fontSize: '15px' }} onClick={onEventClick}>{searchParams.get('url')}</Button>
                            </Stack>

                        </Stack>

                        <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                            <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                            <Button sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                        </Stack>
                    </form>
                </>
            }
        </PrincipalLayouts>
    )
}
